import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-filter',
  templateUrl: './icon-filter.component.html',
  styles: []
})
export class IconFilterComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
